import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#chi-siamo", label: "Chi Siamo" },
  { href: "#cataloghi", label: "Cataloghi Olii" },
  { href: "#preventivi", label: "Preventivi Gasolio" },
  { href: "#adblue", label: "Preventivi AdBlue" },
  { href: "#contatti", label: "Contatti" },
  { href: "#news", label: "News" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-b transition-shadow duration-300 ${
        scrolled ? "border-navy/10 shadow-sm" : "border-transparent"
      }`}
    >
      <nav className="max-w-8xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo" className="flex items-center group shrink-0">
          <img src="/logo-mp.png" alt="Martegiani Petroli Srl" className="h-10 md:h-11 w-auto" />
        </a>

        <div className="hidden lg:flex items-center gap-6 xl:gap-9 lg:ml-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="text-[13px] font-medium uppercase tracking-[0.12em] text-navy hover:text-orange transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#preventivi"
            data-testid="nav-cta"
            className="bg-navy text-white px-5 py-2.5 text-[13px] font-semibold uppercase tracking-[0.12em] hover:bg-orange transition-colors"
          >
            Richiedi Preventivo
          </a>
        </div>

        <button
          className="lg:hidden text-navy"
          data-testid="mobile-menu-btn"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-white border-t border-navy/10"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mnav-${l.href.slice(1)}`}
                  className="text-navy font-medium uppercase tracking-[0.12em] text-sm"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#preventivi"
                onClick={() => setOpen(false)}
                className="bg-navy text-white px-5 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-center"
              >
                Richiedi Preventivo
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
